<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">Part One</span></p>
<p class="PST"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="SANS-B">La Batalla </span><span class="SANS">Ú</span><span class="SANS-B">ltima</span></span></p>
<p class="PSTL"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">(The Last Battle)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?7453ef7f